export const p = {
  capacity: {
    en: "Capacity",
    cn: "價錢",
    jpn: "価格",
  },
  colors: {
    en: "Colors",
    cn: "價錢",
    jpn: "価格",
  },
  feature: {
    en: "Feature",
    cn: "價錢",
    jpn: "価格",
  },
  price: {
    en: "Price",
    cn: "價錢",
    jpn: "価格",
  },
  status: {
    en: "Status",
    cn: "Status",
    jpn: "Status",
  },
  quantity: {
    en: "Quantity",
    cn: "數量",
    jpn: "量",
  },
  size: {
    en: "Selected Size",
    cn: "選擇尺碼",
    jpn: "選択したサイズ",
  },
  color: {
    en: "Selected Color",
    cn: "選擇顏色",
    jpn: "選擇顏色",
  },
  sizeGuide: {
    en: "See Size Chart",
    cn: "查看尺碼對照表",
    jpn: "サイズチャートを見る",
  },
  deliverNReturn: {
    en: "Deliver and Return",
    cn: "交貨和退貨",
    jpn: "配達と返品",
  },
  addToCart: {
    en: "ADD TO CART",
    cn: "加入購物袋",
    jpn: "ショッピングバッグに追加",
  },
  goBack: {
    en: "Go Back",
    cn: "返回",
    jpn: "戻る",
  },
  payment: {
    en: "Acceptable Payment Methods",
    cn: "可接受的付款方式",
    jpn: "利用可能な支払い方法",
  },
};
